import typeToReducer from 'type-to-reducer';

import * as actions from "../actions";

const iniState = {
  tokenRetrieved: false,
  retrieving: false,
  accessToken: null,
  tokenType: null,
  expires: null
}

export const cpp = typeToReducer({
  [actions.CPP_ACCESS_DATA]: {
    PENDING: () => ({
      tokenRetrieved: false,
      retrieving: true,
      accessToken: null,
      tokenType: null,
      expires: null
    }),
    REJECTED: () => ({
      tokenRetrieved: false,
      retrieving: false,
      accessToken: null,
      tokenType: null,
      expires: null
    }),
    FULFILLED: (state, action) => {
      var expires = new Date();
      expires.setSeconds(expires.getSeconds() + action.payload.data.expires_in - 10);
      // I substract 10 seconds to avoid using the token in the second it's going to expire.
      return {
        tokenRetrieved: true,
        retrieving: false,
        accessToken: action.payload.data.access_token,
        tokenType: action.payload.data.token_type,
        expires,
      }
    }
  },
  [actions.CLEAR_FORM]: () => ({
    ...iniState
  })
}, iniState);
